export default {
    state: {
        isCollapse: false,  // 控制菜单展开还是收起
        currentUserPage: 1,
        currentBeltPage: 1
    },
    mutations: {
        // 修改菜单展开收起的方法
        collapseMenu(state, payload) {
            state.isCollapse = payload === undefined ? !state.isCollapse : payload;
        }
    }
}